<template>
  <b-card>
    <b-row>

      <!-- Visit Info: Left col -->
      <b-col
        cols="21"
        xl="6"
        class="d-flex justify-content-between flex-column"
      >
        <!-- Visit Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar
            :src="measurementData.avatar"
            :text="avatarText(objectNumber || 'Ф')"
            variant="light-primary"
            size="104px"
            rounded
          />

          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <p class="text-muted mb-0"><template v-if="hasObject">#{{ objectNumber }} - </template>{{measurementData.date}}</p>
              <h4 class="mb-1">
                <template v-if="hasObject">Замер на обьекте номер {{ objectNumber }}</template>
                <template v-else>{{ measurementData.type && measurementData.type.type || 'Запись' }} без привязки к объекту</template>
              </h4>
            </div>
          </div>
        </div>
        <!-- User Stats -->
        <div class="d-flex align-items-center mt-2">
          <template v-for="measurement_type in linkedTypes">
            <template v-if="measurement_type.measurement_type.id === measurementData.type.id">
              <div class="d-flex align-items-center mr-2">
            <b-avatar
                :variant="`light-${resolveMeasurementValue(measurementData.value, measurement_type.admittance.upper, measurement_type.admittance.lower )}`"
                rounded
            >
              <feather-icon
                icon="HashIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                {{measurementData.value}}
              </h5>
              <small>{{measurementData.type.type}}</small>
            </div>
          </div>
              <div class="d-flex align-items-center mr-2">
            <b-avatar
              variant="light-primary"
              rounded
            >
              <feather-icon
                icon="Maximize2Icon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                {{measurement_type.admittance.lower}} - {{measurement_type.admittance.upper}}
              </h5>
              <small>Допуски</small>
            </div>
          </div>
            </template>
          </template>
        </div>

      </b-col>

      <!-- Right Col: Table -->
      <b-col
        cols="12"
        xl="6"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th>
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Тип обьекта</span>
            </th>
            <td class="pb-50">
              {{ objectTypeName || '—' }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Тип замера</span>
            </th>
            <td class="pb-50">
              {{ measurementData.type.type }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import useMeasurement from "../useMeasurement";
import get from 'lodash.get'


export default {
  components: {
    BCard, BButton, BRow, BCol, BAvatar,
  },
  props: {
    measurementData: {
      type: Object,
      required: true,
    },
  },
  // Объекта у записи может не быть вовсе: фотофиксация со станции и замеры без
  // привязки (межпутье) идут без него. Прежде карточка обращалась к
  // measurementData.object.* без проверки и падала на первой же такой записи
  computed: {
    hasObject() {
      return !!this.measurementData.object
    },
    objectNumber() {
      return get(this.measurementData, 'object.number', '')
    },
    objectTypeName() {
      return get(this.measurementData, 'object.object_type.type', '')
    },
    linkedTypes() {
      return get(this.measurementData, 'object.object_type.measurement_type_for_object_type', []) || []
    },
  },
  setup() {
    const {resolveMeasurementValue} = useMeasurement()
    return {
      resolveMeasurementValue,
      avatarText,
    }
  },
}
</script>

<style>

</style>
